module.exports = __webpack_public_path__ + "src/assets/textures/env/fence/fence_06_1k_bake.png";